"use client";

import * as React from "react";
import { useBreakpointV3 } from "~/hooks/useIsMobile";
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "~/components/shadcn/Popover";
import {
    Command,
    CommandEmpty,
    CommandGroup,
    CommandInput,
    CommandItem,
    CommandList,
} from "~/components/shadcn/Command";
import {
    DrawerTrigger,
    DrawerContent,
    Drawer,
} from "~/components/v4/shadcn/Drawer";
import { Button } from "~/components/v4/themed/Button";
import { Checkbox } from "~/components/shadcn/Checkbox";
import { HiCheck } from "react-icons/hi";

interface SelectCategoryResponsiveProps {
    categories: string[];
    selectedCategories: string[];
    onToggleCategory: (category: string) => void;
}

export function SelectCategoryResponsive({
    categories,
    selectedCategories,
    onToggleCategory,
}: SelectCategoryResponsiveProps) {
    const [open, setOpen] = React.useState(false);
    const isDesktop = useBreakpointV3("md");

    const CategoryList = () => (
        <Command className="min-h-[300px]">
            <CommandInput placeholder="Search categories..." />
            <CommandList>
                <CommandEmpty>No categories found.</CommandEmpty>
                <CommandGroup>
                    {categories.map((category) => {
                        const isSelected =
                            selectedCategories.includes(category);
                        return (
                            <CommandItem
                                key={category}
                                onSelect={() => onToggleCategory(category)}
                                className="flex items-center gap-2"
                            >
                                <div className="flex flex-1 items-center gap-2">
                                    <div
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            onToggleCategory(category);
                                        }}
                                    >
                                        <Checkbox
                                            id={`category-${category}`}
                                            checked={isSelected}
                                        />
                                    </div>
                                    <span
                                        className="flex-1 cursor-pointer"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            onToggleCategory(category);
                                        }}
                                    >
                                        {category}
                                    </span>
                                </div>
                                {isSelected && (
                                    <HiCheck className="h-4 w-4 text-primary" />
                                )}
                            </CommandItem>
                        );
                    })}
                </CommandGroup>
            </CommandList>
        </Command>
    );

    if (isDesktop) {
        return (
            <Popover open={open} onOpenChange={setOpen}>
                <PopoverTrigger asChild>
                    <Button variant="secondary">
                        {selectedCategories.length > 0
                            ? `${selectedCategories.length} ${
                                  selectedCategories.length === 1
                                      ? "category"
                                      : "categories"
                              }`
                            : "Any category"}
                    </Button>
                </PopoverTrigger>
                <PopoverContent className="w-[300px] p-0" align="end">
                    <CategoryList />
                </PopoverContent>
            </Popover>
        );
    }

    return (
        <Drawer open={open} onOpenChange={setOpen}>
            <DrawerTrigger asChild className="z-[100]">
                <Button variant="secondary">
                    {selectedCategories.length > 0
                        ? `${selectedCategories.length} ${
                              selectedCategories.length === 1
                                  ? "category"
                                  : "categories"
                          }`
                        : "Any category"}
                </Button>
            </DrawerTrigger>
            <DrawerContent title="Select Categories">
                <div className="rounded-t-[5px]">
                    <CategoryList />
                </div>
            </DrawerContent>
        </Drawer>
    );
}
